<template>
    <div class="footer-content">
        <div class="content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                EDJON TECHNOLOGY S.A.S.
            </div>
            <div class="item-box">
                <div class="item" v-for="item in list" :key="item.index">
                    <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                    {{ item.content }}
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2026 Copyright belongs to EDJON TECHNOLOGY S.A.S.
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        content: "+593 984375493",
        index: 1,
    },
    {
        content: "Alonso Pablo y Mariscal Sucre  Quito, Pichincha, 170140 Ecuador",
        index: 2,
    },
    {
        content: "manager@edjontechnology.com",
        index: 3,
    }
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 273px;
    background: #191A1E;
    padding: 0 230px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding: 18px 0 35px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.31);

        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            color: #D3D3D3;
            line-height: 15px;
            margin-bottom: 64px;

            img {
                width: 43px;
                height: 43px;
                object-fit: contain;
                margin-right: 12px;
            }
        }

        .item-box {
            width: 100%;
            padding: 0 72px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item {
                max-width: 250px;
                display: flex;
                align-items: center;
                font-weight: 500;
                font-size: 11px;
                color: #DCDCDC;
                line-height: 16px;

                img {
                    width: 27px;
                    height: 27px;
                    object-fit: cover;
                    margin-right: 11px;
                }
            }
        }
    }

    .bottom {
        margin-top: 26px;
        font-weight: 500;
        font-size: 11px;
        color: #989898;
        line-height: 15px;
        text-align: center;
    }
}
</style>